import { render, staticRenderFns } from "./MessageRow.vue?vue&type=template&id=19ef5009&scoped=true&"
import script from "./MessageRow.vue?vue&type=script&lang=js&"
export * from "./MessageRow.vue?vue&type=script&lang=js&"
import style0 from "./MessageRow.vue?vue&type=style&index=0&id=19ef5009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef5009",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ef5009')) {
      api.createRecord('19ef5009', component.options)
    } else {
      api.reload('19ef5009', component.options)
    }
    module.hot.accept("./MessageRow.vue?vue&type=template&id=19ef5009&scoped=true&", function () {
      api.rerender('19ef5009', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rows/MessageRow.vue"
export default component.exports